const UserCheckIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none" {...props}>
      <path
        d="M7.54915 5.70181L8.72949 6.88215L10.5 4.22639M6.375 3.6875C6.375 4.61948 5.61948 5.375 4.6875 5.375C3.75552 5.375 3 4.61948 3 3.6875C3 2.75552 3.75552 2 4.6875 2C5.61948 2 6.375 2.75552 6.375 3.6875ZM1.50046 10.1172C1.50015 10.099 1.5 10.0808 1.5 10.0625C1.5 8.30209 2.92709 6.875 4.6875 6.875C6.44791 6.875 7.875 8.30209 7.875 10.0625V10.0638C7.87499 10.0816 7.87484 10.0994 7.87454 10.1172C6.94368 10.6776 5.85324 11 4.6875 11C3.52176 11 2.43132 10.6776 1.50046 10.1172Z"
        stroke="#1A1A1A"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default UserCheckIcon
